import React, {Component} from 'react';
import {Row, Col, Select, Table, Pagination, Modal, Spin} from 'antd';
import {app, api} from "../../app";
import BigDataFilter from '../../components/BigDataFilter';
import utils from "../../utils";

const Option = Select.Option;

class SignDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posiList: [],
            signList: [],
            pSignList: [],
            teamposition: '0',
            page: 1,
            total: 20,
            rate: 0,
            singin_day: 0,
            rights: app.getData('rights'),
            loading: true,
            attendance: 0,
            absence: 0,
            filter: {},
        };
    }

    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    /**
     * 职位数据
     * @returns {Promise<void>}
     */
    handlePosiData = async () => {
        await this.setData({po_loading: true});
        let {flag, data, msg} = await app.post(api.PosttionList);
        let state = {po_loading: false};
        if (flag === 1) {
            state.posiList = data;
        } else {
            app.alert(msg, 'warn');
        }
        await this.setData(state);
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.handlePosiData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据
     * @returns {Promise<void>}
     */
    dataSource = async (filter, page) => {
        await this.setData({page, signList: [], loading: true});
        let {teamposition} = this.state,
            params = Object.assign({
                page,
                teamposition,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            }, filter);
        let {flag, data, msg, singin_day, rate, total} = await app.post(api.SiginTimeList, params);
        if (flag === 1) {
            if (this.state.page === page) {
                await this.setData({
                    rate,
                    singin_day,
                    signList: utils.addArrayKey(data),
                    total: parseInt(total || '0'),
                    loading: false,
                });
            }
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 个人数据
     * @returns {Promise<void>}
     */
    playerDataSource = async (mark) => {
        await this.setData({pSignList: [], p_loading: true});
        let {filter} = this.state,
            params = {
                mark,
                start_time: filter.start_time,
                end_time: filter.end_time,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
        let {flag, data, msg, attendance, absence} = await app.post(api.SiginTimeData, params);
        if (flag === 1) {
            await this.setData({pSignList: data, attendance, absence, p_loading: false});
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 打开个人弹框
     * @param mark
     * @returns {Promise<void>}
     */
    handleOpenPlayerModal = async (mark) => {
        await this.setData({p_visible: true});
        await this.playerDataSource(mark);
    }

    /**
     * 关闭个人弹框
     * @returns {Promise<void>}
     */
    handleClosePlayerModal = async () => {
        await this.setData({p_visible: false});
    }

    /**
     * 筛选变更
     * @param res
     */
    handleFilterChange = async (filter) => {
        await this.setData({filter});
        await this.dataSource(filter, 1);
    }

    /**
     * 职位筛选变更
     * @param teamposition
     */
    handlePositionChange = async (value) => {
        let teamposition = value.join(',') || '0';
        await this.setData({teamposition});
        let {filter} = this.state;
        await this.dataSource(filter, 1);
    }

    render() {
        let {
                posiList, signList, loading, page, filter, total, singin_day, rate, rights, p_visible, pSignList,
                p_loading, po_loading, attendance, absence,
            } = this.state,
            sign_rights = app.getData('sign_rights'),
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '20%'
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '15%'
                },
                {
                    title: '身份',
                    dataIndex: 'state',
                    key: 'state',
                    width: '15%',
                    render(text) {
                        return (<span>{text || "无"}</span>);
                    }
                },
                {
                    title: '签到状态',
                    dataIndex: 'is_leave',
                    key: 'is_leave',
                    width: '10%',
                    render(is_leave) {
                        return (<span>{is_leave === 1 ? "已签到" : "未签到"}</span>);
                    }
                },
                {
                    title: '个人签到率',
                    dataIndex: 'rate',
                    key: 'rate',
                    width: '20%',
                    render(rate) {
                        return (<span>{rate || 0}%</span>);
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'indexno',
                    key: 'indexno',
                    width: '20%',
                    render: (indexno) => {
                        return (<span style={{color: '#3399CC', cursor: 'pointer'}}
                                      onClick={() => this.handleOpenPlayerModal(indexno)}>查看签到记录</span>);
                    }
                },
            ];
        return (
            <div className="sign-data page">
                <div className="page-title">签到时间</div>
                <div className="page-content">
                    <BigDataFilter hasDate={true} change={this.handleFilterChange}/>
                    <div className="posi-filter">
                        <span>队内职务：</span>
                        <Select style={{marginLeft: 10, minWidth: 200, maxWidth: 'calc(100% - 80px)'}} mode="multiple"
                                onChange={this.handlePositionChange}
                                notFoundContent={po_loading ? <Spin size="small"/> : '暂无记录'}
                                disabled={rights !== 1 && sign_rights != 1} placeholder="默认全部职务" allowClear>
                            {
                                posiList.map((posi, i) => {
                                    return (
                                        <Option key={i} value={posi.position_id}>{posi.position_name}</Option>
                                    );
                                })
                            }
                        </Select>
                    </div>
                    <Table columns={columns}
                           loading={loading}
                           locale={app.tbLocale(loading)}
                           dataSource={signList}
                           scroll={{y: 'calc(100% - 120px)'}}
                           size="small"
                           pagination={false}
                           footer={() => {
                               return (
                                   <Row className="table-footer" gutter={20} type="flex" align="middle">
                                       <Col className="tf-sn-count" span={14}>
                                           <span>人数：{total || 0}人</span>
                                           <span>平均签到率：{rate || 0}%</span>
                                           <span>共需要签到：{singin_day || 0}日</span>
                                       </Col>
                                       <Col span={10} style={{textAlign: 'right'}}>
                                           <Pagination current={page} total={total} pageSize={20}
                                                       onChange={async (page) => {
                                                           await this.dataSource(filter, page);
                                                       }}/>
                                       </Col>
                                   </Row>
                               )
                           }
                           }
                    />
                    <Modal visible={p_visible}
                           width={500}
                           title={<div style={{textAlign: 'center', fontWeight: 'bold'}}>查看签到记录</div>}
                           footer={null}
                           onCancel={this.handleClosePlayerModal}>
                        {
                            p_loading ? (<Spin/>) :
                                (
                                    <div>
                                        <div style={{color: '#ccc'}}>{filter.start_time} ~ {filter.end_time}</div>
                                        <div style={{margin: '10px 0 20px 0', color: '#ccc'}}>
                                            <span style={{marginRight: 20}}>出勤数 <span
                                                style={{color: '#666'}}>{attendance || 0}日</span></span>
                                            <span>缺席数 <span style={{color: '#666'}}>{absence || 0}日</span></span>
                                        </div>
                                        <div style={{maxHeight: 500, overflowY: 'auto'}}>
                                            {
                                                pSignList.map((p, i) => {
                                                    return (
                                                        <Row key={i} gutter={10} style={{margin: '5px 0'}}>
                                                            <Col span={6} style={{color: '#999'}}>{p.day}</Col>
                                                            <Col span={4}>{p.is_leave === 1 ?
                                                                <span style={{color: '#33CC99'}}>已签到</span> :
                                                                <span style={{color: '#999'}}>未签到</span>}</Col>
                                                            <Col span={12}
                                                                 hidden={!p.singin_time}>签到时间：{p.singin_time}</Col>
                                                        </Row>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                        }
                    </Modal>
                </div>
            </div>
        );
    }
}

export default SignDate;



// WEBPACK FOOTER //
// ./src/routes/bigData/SignDate.jsx